import React from 'react';
import { Marquee } from './Marquee';
export function Header() {
  return <header className="mb-8 flex flex-col items-center justify-center text-center" data-id="element-111">
      <div className="retro-border-double w-full max-w-4xl bg-[#ff69b4] p-6 retro-shadow mb-6 relative overflow-hidden" data-id="element-112">
        {/* Decorative corner stars */}
        <div className="absolute top-2 left-2 text-3xl animate-spin" style={{
        animationDuration: '3s'
      }} data-id="element-113">
          ⭐
        </div>
        <div className="absolute top-2 right-2 text-3xl animate-spin" style={{
        animationDuration: '3s'
      }} data-id="element-114">
          ⭐
        </div>
        <div className="absolute bottom-2 left-2 text-3xl animate-spin" style={{
        animationDuration: '3s'
      }} data-id="element-115">
          ⭐
        </div>
        <div className="absolute bottom-2 right-2 text-3xl animate-spin" style={{
        animationDuration: '3s'
      }} data-id="element-116">
          ⭐
        </div>

        <h1 className="text-4xl md:text-6xl text-white text-shadow-retro mb-4 tracking-wider leading-tight" data-id="element-117">
          ~*~ CeDrInE's #1 FaN pAgE ~*~
        </h1>

        <div className="my-4" data-id="element-118">
          <img src="https://cdn.magicpatterns.com/uploads/92YyMhz9So25ws3RMaUCuJ/ChatGPT_Image_Mar_14,_2026,_11_34_55_AM.png" alt="Cedrine Dion performing on stage!!!" className="mx-auto w-48 h-48 md:w-64 md:h-64 object-cover border-4 border-white shadow-lg" style={{
          borderStyle: 'ridge',
          borderColor: '#FFD700',
          borderWidth: '6px'
        }} data-id="element-119" />
          <p className="text-white text-sm mt-1 italic" data-id="element-120">
            ~*~ Our Queen SLAYING on stage!!! ~*~
          </p>
        </div>

        <h2 className="text-xl md:text-2xl text-yellow-200 font-bold mb-4 animate-blink" style={{
        textShadow: '1px 1px 2px #000'
      }} data-id="element-121">
          The ULTIMATE fan site for the greatest singer EVER!!! 💖✨
        </h2>

        <div className="bg-black text-[#00ff00] p-2 border-2 border-[#00ff00] font-mono text-sm md:text-base" data-id="element-122">
          <Marquee data-id="element-123">
            Welcome to the #1 Cedrine Dion fan page on the ENTIRE internet!!!
            💖✨💖✨ IF YOU DON'T LIKE CEDRINE YOU CAN LEAVE NOW!!! 😤😤😤 ~*~
            Updates every day! ~*~
          </Marquee>
        </div>
      </div>

      <nav className="bg-white retro-border p-4 flex flex-wrap justify-center gap-4 md:gap-8 w-full max-w-3xl retro-shadow" data-id="element-124">
        <a href="#home" className="text-[#ff1493] hover:text-[#0000ff] hover:underline font-bold text-xl" data-id="element-125">
          [HOME]
        </a>
        <a href="#blogs" className="text-[#ff1493] hover:text-[#0000ff] hover:underline font-bold text-xl" data-id="element-126">
          [NEWS & BLOGS]
        </a>
        <a href="#fanfic" className="text-[#ff1493] hover:text-[#0000ff] hover:underline font-bold text-xl" data-id="element-127">
          [FAN FICTION]
        </a>
        <a href="#secret" className="text-[#ff1493] hover:text-[#0000ff] hover:underline font-bold text-xl" data-id="element-128">
          [SECRET ZONE]
        </a>
      </nav>
    </header>;
}